import { createRouter, createWebHistory } from "vue-router";
import AppRoot from "@app/app-root.vue";
import { appRoutes } from "@/app/router/app-routes";
import { publicRoutes } from "@/app/router/public-routes";

const routes = [
    
    {
        children: [
            ...publicRoutes,
            ...appRoutes
        ],

        component: AppRoot,
        path: "/",
        name: "home",
        redirect: "/prijava", // this is the default public view
    },

];
const router = createRouter({
    history: createWebHistory(""),
    routes,
    scrollBehavior(to, from, savedPosition: any) {
        if (savedPosition) {
          return savedPosition;
        }
        if (to.hash) {
          
          return { 
            el: to.hash,
            behavior: 'smooth',
          };
        }
        return { top: 0  };
      }
    });

  router.beforeEach((to, from, next) => {
    const protectedPublicSteps = ["sign_in_two", "complete-profile"];
    const isDirectAccess = !from.name;

    if (protectedPublicSteps.includes(String(to.name)) && isDirectAccess) {
      next({ name: "sign_in" });
      return;
    }

    next();
  });

// router.afterEach((to, from) => {
//     if (to.meta.hasLPTag != undefined && to.meta.hasLPTag == false) {
//         if (window.lpTag) {
//             window.lpTag.newPage("https://newpos.takoleasy.si/noLP");
//         }
//     } else {
//         if (window.lpTag) {
//             window.lpTag.newPage("https://newpos.takoleasy.si");
//         }
//     }
// });

export default router;